module.exports = __webpack_public_path__ + "img/serviceDetail2.28b81ab4.png";